module.exports = __webpack_public_path__ + "static/media/scissors-light_thumbnail.f6a34995.png";